// Components - UI
import Scroller from '@/components/ui/Scroller/Scroller.vue';
import UserIcon from '@/components/ui/UserIcon/UserIcon.vue';
import LineChart from '@/components/ui/LineChart/LineChart.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import WashroomIcon from '@/components/ui/WashroomIcon/WashroomIcon.vue';
import ServiceIcons from '@/components/ui/ServiceIcons/ServiceIcons.vue';
import WashroomsCount from '@/components/ui/WashroomsCount/WashroomsCount.vue';

// Services
import RetailersService from '@/services/RetailersService.js';
import WashroomsService from '@/services/WashroomsService.js';
import ReviewsService from '@/services/ReviewsService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

// EventBus
import { EventBus } from '@/EventBus.js';

// Vendor
import moment from 'moment';

export default {

  name: 'retailers-detail',

  components: {
    Scroller,
    UserIcon,
    LineChart,
    ReviewStars,
    WashroomIcon,
    ServiceIcons,
    WashroomsCount
  },

  data: function() {
    return {
      retailer: null,
      washrooms: null,
      reviews: null,
      serviceRelationships: null,
      userMode: 'normal',
      userGroup: null,

      // Chart State
      activeChart: 1,

      // Chart Data
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    }
  },

  created: function() {
    let retailerId = this.$route.params.id;

    let serviceRelationshipFilter = null;

    this.userGroup = localStorage.getItem('userGroup');

    // Check the logged in user type and adjust the view if neccesary
    if(localStorage.getItem('userGroup') == 'service-providers') {
      this.userMode = 'service-providers';
      serviceRelationshipFilter = {
        retailer: retailerId,
        serviceProvider: localStorage.getItem('parentId')   // In this case `parentId` is the logged in service user's id
      };
    }
    else {
      serviceRelationshipFilter = {
        retailer: retailerId
      };
    }

    // Populate page data
    // ------------------
    // Reviews Per Day (Chart Data)
    ReviewsService.getPerDay(7, {retailer: retailerId}, null, null, 'createdAt ASC')
      .then((res) => {
        this.recentReviewsPerDay = res.data;
      });

    // Average Rating Per Day (Chart Data)
    ReviewsService.getAverageRatingPerDay(7, {retailer: retailerId}, null, null, 'createdAt ASC')
      .then((res) => {
        this.recentAverageRatingPerDay = res.data;
      });

    RetailersService.getById(retailerId)
      .then((res) => {
        this.retailer = res.data;
      })
      .catch((err) => {
        console.error('RetailersService(err)', err);
      });

    WashroomsService.getAll({retailer: retailerId})
      .then((res) => {
        this.washrooms = res.data;
      })
      .catch((err) => {
        console.error();('WashroomsService(err)', err);
      });

    ReviewsService.getAll({retailer: retailerId}, null, null, 'createdAt DESC')
      .then((res) => {
        this.reviews = res.data;
      })
      .catch((err) => {
        console.error('ReviewsService(err)', err);
      });

    ServiceRelationshipsService.getAll(serviceRelationshipFilter)
      .then((res) => {
        this.serviceRelationships = res.data;
      })
      .catch((err) => {
        console.error('ServiceRelationshipsService(err)', err);
      })
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    filterWashrooms: function(washroom) {
      return this.washrooms.find((item) => item.id == washroom.id);
    },

    reviewsPerDayLabels: function(data) {
      if(data !== null) {
        let labels = [];

        for (let i in data) {
          labels.push(moment(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    reviewsPerDayPlots: function(data) {
      if(data !== null) {
        let plots = [];

        for (let i in data) {
          plots.push(data[i].reviews.length);
        }

        return plots;
      }

      return null;
    },

    averageRatingPerDayLabels: function(data) {
      if(data !== null) {
        let labels = [];

        for (let i in data) {
          labels.push(moment(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    averageRatingPerDayPlots: function(data) {
      if(data !== null) {
        let plots = [];

        for (let i in data) {
          plots.push(data[i].averageRating);
        }

        return plots;
      }

      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/RetailersDetail/RetailersDetail.js